export interface BudgetFilterValue {
  flight?: number | string;
  stay?: number | string;
  dine?: string;
  experience?: string;
}

export interface BudgetToggleState {
  FLIGHT: boolean;
  STAY: boolean;
  DINE: boolean;
  EXPERIENCE: boolean;
}

export const budgetToggleDefaultState: Readonly<BudgetToggleState> = {
  FLIGHT: true,
  STAY: true,
  DINE: true,
  EXPERIENCE: true,
};

export const budgetDefultValue: Readonly<BudgetFilterValue> = {
  flight: 'Select Budget...',
  stay: 'Select Budget...',
  dine: 'Select Budget...',
  experience: 'Select Budget...',
};
